<template>
   <v-container fluid>
      <v-row no-gutters>
         <v-btn :disabled="multiselect" small outlined color="indigo" @click="addParticipant">
            <v-icon left small>mdi-plus</v-icon>
            <template v-if="$vuetify.breakpoint.mdAndUp">Add Participant</template>
         </v-btn>
         <v-btn
            :disabled="!multiselect"
            small
            outlined
            color="indigo"
            class="ml-4"
            @click="removeParticipant"
         >
            <v-icon left small>mdi-minus</v-icon>
            <template v-if="$vuetify.breakpoint.mdAndUp">Remove Participant</template>
         </v-btn>
         <v-btn
            :disabled="!multiselect"
            small
            outlined
            color="indigo"
            class="ml-4"
            @click="moveToWaitList"
         >
            <v-icon left small>mdi-arrow-down</v-icon>
            <template v-if="$vuetify.breakpoint.mdAndUp">Move To Waitlist</template>
         </v-btn>
         <v-btn
            :disabled="multiselect"
            small
            outlined
            color="indigo"
            class="ml-4"
            @click="reloadParticipantList"
         >
            <v-icon left>mdi-refresh</v-icon>
            <template v-if="$vuetify.breakpoint.mdAndUp">Refresh</template>
         </v-btn>
         <v-spacer></v-spacer>
         <v-checkbox
            class="ml-4 mt-n1"
            :disabled="participantdata.length == 0"
            label="Select"
            v-model="multiselect"
            @click="multiSelectClick"
         >
         </v-checkbox>
      </v-row>
      <v-row class="py-3">
         <v-col cols="12" md="8">
            <v-btn
               small
               :disabled="participantdata.length == 0"
               outlined
               color="indigo"
               @click="generateParticipantList"
            >
               Export List
            </v-btn>
            <v-btn
               small
               class="ml-2"
               :disabled="disableUpdateDueDateBtn"
               outlined
               color="indigo"
               @click="updateDueDate"
            >
               Update Due Date
            </v-btn>
         </v-col>
         <v-col cols="12" md="4">
            <v-text-field
               :disabled="disablePaymentFilter"
               label="Filter"
               dense
               v-model="paymentFilter"
               hide-details
            ></v-text-field>
         </v-col>
      </v-row>
      <!-- participant table -->
      <v-card flat outlined>
         <v-row no-gutters>
            <v-col cols="12" md="8" class="px-2"> </v-col>
         </v-row>
         <v-data-table
            v-model="selectedparticipant"
            dense
            :headers="participant_header"
            :items="participantdata"
            :sort-by="participantsort"
            item-key="school_id"
            :single-select="!multiselect"
            @click:row="participant_rowClick"
            selectable-key="isSelectable"
            :show-select="multiselect"
            :search="paymentFilter"
         >
         </v-data-table>
      </v-card>
      <confirm-reason-dlg ref="confirmreason" @save-reason="saveReason"></confirm-reason-dlg>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <student-list
         :gender="gender"
         :year="year"
         :data="participantdata"
         :dialogvisible.sync="studentlistdlg"
         :maxselection="this.max_participant"
         @cancel-selection="studentlistdlg = false"
         @save-selection="onSaveStudentSelection"
      ></student-list>
   </v-container>
</template>

<script>
   import CapConstant from "@/common/capconstant.js";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ConfirmReasonDlg from "@/components/ConfirmReasonDlg.vue";
   import StudentList from "@/components/StudentList.vue";

   export default {
      props: {
         max_participant: Number,
         cca_id: [Number, String],
         consent: [Boolean, Number],
         gender: Object,
         year: Array,
         participants: Array,
         ccafee: Number,
         closingdate: String,
      },
      inject: ["ShowMessage"],

      components: {ConfirmDlg, ConfirmReasonDlg, StudentList},

      data() {
         return {
            CapConstant: Object.freeze(CapConstant),

            participant_header: [
               {
                  text: "Code",
                  align: "start",
                  value: "student_code",
                  width: "7%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Name",
                  value: "fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Gender",
                  value: "gendertext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Type",
                  value: "subtypetext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Year",
                  value: "yeartext",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Tran ID",
                  value: "ccatran_id",
                  width: "8%",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Consent",
                  value: "consentstatustext",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            paymentFilter: "",
            pendingapproval_count: 0,
            approvedunpaid_count: 0,
            paid_count: 0,
            selectedparticipant: [],
            participantdata: this.participants,
            participantsort: ["fullname"],
            studentlistdlg: false,
            multiselect: false,
            actionReason: "",
            deleteReason: "",
            moveReason: "",
         };
      },

      computed: {
         disableUpdateDueDateBtn() {
            return this.participantdata.length > 0 &&
               this.$globalstore.roundCurrency(this.ccafee) > 0 &&
               this.$globalstore.UserHasCap(this.CapConstant.UPDATE_DUE_DATE)
               ? false
               : true;
         },

         disablePaymentFilter() {
            return this.multiselect ? true : false;
         },
      },

      methods: {
         multiSelectClick() {
            if (!this.multiselect) {
               this.selectedparticipant = [];
            } else {
               this.paymentFilter = "";
            }
         },

         participant_rowClick(item, row) {
            row.select(!row.isSelected);
         },

         async onSaveStudentSelection(studentlist) {
            this.studentlistdlg = false;
            if (studentlist.length > 0) {
               await this.saveParticipant(studentlist);
               await this.reloadParticipantList();
            }
         },

         async saveParticipant(studentlist) {
            await this.$http({
               url: "/cca/saveparticipant.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  pcp: studentlist,
                  subtype: 2, // Invited
                  cca_id: this.cca_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  }
               }
            });
         },

         async addParticipant() {
            if (this.max_participant !== 0 && this.participantdata.length >= this.max_participant) {
               this.ShowMessage({
                  title: "Error",
                  message: "You have reached the maximum participants.",
                  color: "red",
               });
            } else {
               if (this.ccafee > 0) {
                  this.$refs.confirm
                     .open(
                        "Payment Required",
                        "This is activity requires payment for participation. " +
                           "A request for payment will be created for the selected students. " +
                           "Do you wish to continue?",
                        {color: "green", noconfirm: false}
                     )
                     .then((reply) => {
                        if (reply) {
                           this.studentlistdlg = true;
                        }
                     });
               } else {
                  this.studentlistdlg = true;
               }
            }
         },

         async removeParticipant() {
            if (this.selectedparticipant.length > 0) {
               let msg;
               if (this.ccafee > 0) {
                  msg =
                     "Are you sure you want to remove the selected participant(s)? If yes, " +
                     "this will require the Billing Department to cancel any associated invoice/receipt. " +
                     "Please provide a reason below and notify the Billing Department at fee@kl.his.edu.my";
               } else {
                  msg =
                     "Are you sure you want to remove the selected participant(s)? If yes, please provide a reason below.";
               }

               await this.$refs.confirmreason
                  .open("Warning", msg, {color: "orange"})
                  .then((reply) => {
                     if (reply) {
                        this.deleteReason = this.actionReason;
                        this.doRemoveParticipant();
                     }
                  });
            }
         },

         saveReason(reason) {
            this.actionReason = reason;
         },

         async doRemoveParticipant() {
            if (this.selectedparticipant.length > 0) {
               await this.$http({
                  url: "/cca/removeparticipant.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.cca_id,
                     participantlist: this.selectedparticipant,
                     reason: this.deleteReason,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.reloadParticipantList();
                        this.$emit("save-participantlist", this.participantdata);
                     }
                  }
               });
            }
         },

         async moveToWaitList() {
            if (this.selectedparticipant.length > 0) {
               await this.$refs.confirmreason
                  .open(
                     "Warning",
                     "Are you sure you want to move the selected participants " +
                        "to the waitlist? This may require Billing Department to cancel any associated invoice/receipt. " +
                        "Please provide a reason below.",
                     {color: "orange"}
                  )
                  .then((reply) => {
                     if (reply) {
                        this.moveReason = this.actionReason;
                        this.doMoveToWaitList();
                     }
                  });
            }
         },

         async doMoveToWaitList() {
            await this.$http({
               url: "/cca/movetowaitlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  participantlist: this.selectedparticipant,
                  reason: this.moveReason,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadParticipantList();
                     this.$emit("update-waitlist");
                  }
               }
            });
         },

         async reloadParticipantList() {
            await this.$http({
               url: "/cca/getparticipantlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.participantdata = response.data.participantdata;
                  }
               }
            });
         },

         generateParticipantList() {
            if (this.participantdata.length > 0) {
               this.$refs.confirm
                  .open("Confirm", "Are you sure you want to export the participant list?", {
                     color: "primary",
                     noconfirm: false,
                  })
                  .then((reply) => {
                     if (reply) {
                        this.doExportList();
                     }
                  });
            }
         },

         updateDueDate() {
            let fee = Number(Number.parseFloat(this.ccafee).toFixed(2));
            if (this.participantdata.length > 0 && fee > 0) {
               let closedate = this.$date(this.closingdate);
               let newdate = closedate.add(
                  parseInt(this.$globalstore.appsettings.cca_payment_grace_days),
                  "day"
               );

               let today = this.$date();
               if (today > newdate) {
                  this.ShowMessage({
                     title: "Error",
                     message:
                        "Closing date is set to " +
                        this.closingdate +
                        " and new due date will be " +
                        newdate.format("YYYY-MM-DD") +
                        " which has already passed.",
                     color: "red",
                  });
                  return;
               } else {
                  let newdatestr = newdate.format("YYYY-MM-DD");
                  this.$refs.confirm
                     .open(
                        "Confirm",
                        "Are you sure you want to update the due dates of unpaid transactions to " +
                           newdatestr +
                           "?",
                        {color: "primary", noconfirm: false}
                     )
                     .then((reply) => {
                        if (reply) {
                           this.doUpdateDueDate(newdatestr);
                        }
                     });
               }
            }
         },

         async doUpdateDueDate(newduedate) {
            await this.$http({
               url: "/cca/cca_update_duedate.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  new_duedate: newduedate,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.ShowMessage({
                        title: "Information",
                        message: response.data.message,
                        color: "success",
                     });
                  }
               }
            });
         },

         async doExportList() {
            await this.$http({
               url: "/cca/exportparticipantlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.cca_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
               responseType: "blob",
            }).then((response) => {
               if (!(response.data instanceof Blob)) {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     }
                     return;
                  }
               } else {
                  const url = window.URL.createObjectURL(response.data);
                  try {
                     const link = document.createElement("a");
                     link.href = url;
                     let filename = "ParticipantList.xlsx";
                     link.setAttribute("download", filename);
                     document.body.appendChild(link);
                     link.click();
                  } finally {
                     window.URL.revokeObjectURL(url);
                     this.report_in_progress = false;
                  }
               }
            });
         },
      },
   };
</script>
